import { ROUTES } from '@/constants';

export const sidebarItems = [
	{ label: 'Presentación', to: ROUTES.COLEGIO_PRESENTACION },
	{
		label: 'Organización',
		children: [
			{ label: 'Junta Directiva', to: ROUTES.COLEGIO_JUNTA_DIRECTIVA },
			{ label: 'Departamentos', to: ROUTES.COLEGIO_DEPARTAMENTOS },
			{ label: 'Notarios', to: ROUTES.COLEGIO_NOTARIOS },
		],
	},
	{ label: 'Visita Virtual', to: ROUTES.COLEGIO_VISITA_VIRTUAL },
];
